import { useMutation, useQuery, } from "react-query";
import { useToast } from "../../../hooks/usetoast";
import DataService from '../../../config/DataServices'
import { queryClient } from "../../../config";

const { getRequest, putRequest } = DataService()

export const useGetCoins = ({ page, size, searchText, sortOrder, sortField }) => {

    return useQuery({
        queryKey: ["coin-list", page, size, searchText, sortOrder, sortField],
        queryFn: () => {
            return getRequest(`/get-coins?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}`)
        }
    })
}

export const useGetSingleCoin = (id) => {
    return useQuery({
        queryFn: () => {
            return getRequest(`/view-coin/${id}`)
        },
    })
}

export const useUpdateFeeStatus = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: ({ sendFee, internalFee, _id, status, minInternalTransfer, minTransfer }) => {
            return putRequest(`/update-coin/${_id}`, { sendFee, internalFee, status, minInternalTransfer, minTransfer })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("coin-list");
            return toast.success(success?.data?.message)
        }
    })
}

export const useUpdateFee = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return putRequest(`/update-coin/${data._id}`, { sendFee: data.sendFee, internalFee: data.internalFee, name: data.name, minInternalTransfer: data.minInternalTransfer, minTransfer: data.minTransfer })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("coin-list");
            return toast.success(success?.data?.message)
        }
    })
}